import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ProjectForm from './pages/ProjectForm';
import ChecklistWorkflow from './pages/ChecklistWorkflow';
import AuthModal from './components/AuthModal';
import { ProjectProvider } from './context/ProjectContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function AppContent() {
  const { isAuthenticated, showAuthModal } = useAuth();

  if (!isAuthenticated) {
    return <AuthModal />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/project/new" element={<ProjectForm />} />
        <Route path="/project/:id/edit" element={<ProjectForm />} />
        <Route path="/project/:id/checklist" element={<ChecklistWorkflow />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <Router>
          <AppContent />
        </Router>
      </ProjectProvider>
    </AuthProvider>
  );
}

export default App;